import React from "react";
import Market from "../../img/dropshipping.jpg";

export default function About() {
  return (
    <div className="max-w-2xl mx-auto pb-24 px-4 grid items-center grid-cols-1 gap-y-16 gap-x-8 sm:px-6 sm:pb-32 lg:max-w-7xl lg:px-8 lg:grid-cols-2">
      <div className="grid grid-cols-1 grid-rows1 gap-4 sm:gap-6 lg:gap-8">
        <img
          src={Market}
          alt="Walnut card tray with white powder coated steel divider and 3 punchout holes."
          className="bg-gray-100 rounded-lg"
        />
      </div>
      <div>
        <h2 className="text-2xl font-extrabold tracking-tight text-gray-900 sm:text-4xl">
          About PAYCOLIFE
        </h2>
        <p className="mt-4 text-gray-500">
          In March 2020, <br /> as a result of the pandemic entering our lives,
          our PayCoLife company started its e-commerce life in New Mexico/USA.{" "}
          <br />
          We promised to be with you, our valued users, with the "Auto
          DropShipping" system we prepared for the recovery of our badly
          affected individual economy system. <br />
          For those who do not know how to do DropShipping, in the PayCoLife
          system, which allows them to do this automatically, you can catch the
          necessary opportunities to fix your economy without getting tired and
          without any effort.
          <br /> <br />
          PayCoLife, in this system that makes you happier and more peaceful,
          regardless of the economic conditions of the world and countries, with
          8 servers and 24/7 active robots, automatically performs drop shipping
          for you.
          <br />
          <br />
          PayCoLife is My Financial Life!
        </p>
      </div>
    </div>
  );
}
